import { Building2Icon, ClipboardListIcon, MissionIcon } from 'assets/icons';
import SlideOverBody from 'components/SlideOver/component/body';
import SlideOverHeader from 'components/SlideOver/component/header';
import useSlideOver from 'components/SlideOver/useSlideOver';
import { canCreateMission } from 'components/sidebar/sidebarLinks';
import useTaskPanels from 'hooks/useTaskPanels';
import useText from 'hooks/useText';
import Usefetchdata from 'hooks/usefetchdata';

export const CREATE_MENU_PANEL = 'create_menu';

/**
 * The « Créer » panel of the sidebar, as on the prototype: what to create (a
 * task, a company or a mission), each opening its own form in its place.
 * « Une mission » is left out for whoever may not create one (the Commercial).
 */
const CreateMenuPanel = () => {
  const { text } = useText('createMenu');
  const { toggleSlideOver } = useSlideOver();
  const { openTaskForm } = useTaskPanels();
  const { userData } = Usefetchdata();
  const choices = [
    { id: 'task', icon: ClipboardListIcon, open: () => openTaskForm({ defaults: { type: 'todo' } }) },
    { id: 'company', icon: Building2Icon, open: () => toggleSlideOver('add_company') },
    canCreateMission(userData) && {
      id: 'mission',
      icon: MissionIcon,
      open: () => toggleSlideOver('add_mission'),
    },
  ].filter(Boolean);
  return (
    <>
      <SlideOverHeader hide={() => toggleSlideOver()} closeLabel={text('close')} description={text('description')}>
        {text('title')}
      </SlideOverHeader>
      <SlideOverBody className="flex flex-col gap-2">
        {choices.map(({ id, icon: Icon, open }) => (
          <button
            key={id}
            type="button"
            onClick={open}
            className="flex items-center gap-4 rounded-xl border border-gray-200 p-4 text-left transition-colors hover:border-yellow-500 hover:bg-yellow-50"
          >
            <span className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-900">
              <Icon wh={20} color="currentColor" />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-semibold text-gray-900">{text(id)}</span>
              <span className="block text-xs text-gray-600">{text(`${id}Text`)}</span>
            </span>
          </button>
        ))}
      </SlideOverBody>
    </>
  );
};

export default CreateMenuPanel;
